
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(12684|48209)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
